import { useQuery } from '@tanstack/react-query';
import api from 'api';
import { getMixpanelErrorProps } from 'axiosUtils';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import { ReleaseOrderStatus } from 'models/WorkflowConfiguration';
import mixpanelService from 'services/mixpanelService';

export const RELEASE_ORDER_STATUS_QUERY_KEY = 'release-order-status';

export default function useReleaseOrderStatusQuery(
  leadId: string,
  isEnabled: boolean,
) {
  const getMixpanelProps = useGetMixpanelProps();

  const query = useQuery<ReleaseOrderStatus>({
    queryKey: [RELEASE_ORDER_STATUS_QUERY_KEY, { leadId }],
    queryFn: async () => {
      const { data } = await api.portfolio.seller.getReleaseOrderStatus(leadId);

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: !!leadId && isEnabled,
    staleTime: 0,
  });

  useInvalidateQueryOnUnmount(RELEASE_ORDER_STATUS_QUERY_KEY);

  return query;
}
